// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1ajXZ","author":"Table_author__23IGR","authorImage":"Table_authorImage__190SO","unreadRow":"Table_unreadRow__33OuH"};